import React from 'react';
import BrandIcon, { BrandGradient } from './BrandIcon';

// Empty-state mark for the Cap Table: a pie chart (dial circle split by two
// radii) inside the gradient-bordered tile. See BrandIcon for the shared frame
// and the per-instance gradient ids.
const CapTableIcon = (props) => {
  const uid = React.useId();
  const g = (n) => `cap_table_${uid}_${n}`;
  const paint = (id) => props.color ?? `url(#${id})`;

  return (
    <BrandIcon
      {...props}
      defs={
        <>
          <BrandGradient id={g('dial')} x1="10" y1="30.5" x2="47.9501" y2="70.4474" />
          <BrandGradient id={g('radiusTop')} x1="39.7309" y1="26.937" x2="41.7237" y2="27.0602" />
          <BrandGradient id={g('radiusRight')} x1="35.75" y1="42.25" x2="43.1932" y2="56.3095" />
        </>
      }
    >
      <path
        d="M40 22.25C50.4165 22.25 58.75 30.2566 58.75 40C58.75 49.7434 50.4165 57.75 40 57.75C29.5835 57.75 21.25 49.7434 21.25 40C21.25 30.2566 29.5835 22.25 40 22.25Z"
        stroke={paint(g('dial'))}
        strokeWidth="2.5"
      />
      <path
        d="M38.6734 39.9951C38.6704 40.6855 39.2276 41.2474 39.9179 41.2501C40.6083 41.2528 41.1704 40.6954 41.1734 40.0051L39.9234 40.0001L38.6734 39.9951ZM41.25 22.5889C41.253 21.8986 40.6958 21.3367 40.0055 21.334C39.3151 21.3313 38.753 21.8887 38.75 22.579L40 22.584L41.25 22.5889ZM39.9234 40.0001L41.1734 40.0051L41.25 22.5889L40 22.584L38.75 22.579L38.6734 39.9951L39.9234 40.0001Z"
        fill={paint(g('radiusTop'))}
      />
      <path
        d="M40 40L57 49"
        stroke={paint(g('radiusRight'))}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BrandIcon>
  );
};

export default CapTableIcon;
